import { render, staticRenderFns } from "./CreateDashboardWidget.vue?vue&type=template&id=f6427cfc"
import script from "./CreateDashboardWidget.vue?vue&type=script&lang=js"
export * from "./CreateDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./CreateDashboardWidget.vue?vue&type=style&index=0&id=f6427cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports